import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { headN } from '@cullylarson/f';
import { hasItem } from '@@client/cart/cart-repo';
import { useCart } from '@@client/cart/cart-hooks';
import Col100 from '@@client/components/Col100';
import PartCardList from '@@client/parts/PartCardList';
export default function RecentlyViewedParts(_ref) {
  var className = _ref.className,
      _ref$whitelistIds = _ref.whitelistIds,
      whitelistIds = _ref$whitelistIds === void 0 ? [] : _ref$whitelistIds;
  var cart = useCart(); // to prevent nextjs errors with the server/client rendering differently (because the cart is on the client),
  // need to set parts in a useEffect call.

  var _useState = useState([]),
      parts = _useState[0],
      setParts = _useState[1];

  useEffect(function () {
    setParts(headN(6, cart.recentlyViewed.filter(function (x) {
      // don't include whitelisted parts or parts already in cart
      return !whitelistIds.includes(x.inventoryId) && !hasItem(cart.items, x.inventoryId);
    })));
  }, [cart.recentlyViewed]);
  if (!parts.length) return null;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(Col100, {
      children: /*#__PURE__*/_jsx(PartCardList, {
        headingBg: "gray",
        heading: "Recently Viewed",
        parts: parts
      })
    })
  });
}